import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'

import {
    PROMOTION_CREATE,
    PROMOTION_FETCH,
    PROMOTION_FETCH_BY_ID,
    PROMOTION_UPDATE
} from './types';

export const promotionDeleteById = (id, files) => {
    return (dispatch) => {
        firebase.database().ref('promotions/'+id).remove()
        .then(() => removeTwoOldFile(files))
    }
}

const removeTwoOldFile = (files) => {
    const ref = firebase.storage().ref().child(files.oldThumbnail);
    // Delete the file
    ref.delete().then(() => {
        const ref2 = firebase.storage().ref().child(files.oldPhoto);
        ref2.delete().then(() => {
            window.location = "/admin/promotion"
        }).catch(error => window.location = "/admin/promotion")
    }).catch((error) => {
        window.location = "/admin/promotion"
    });
}

const removeOldFile = (src) => {
    const ref = firebase.storage().ref().child(src);
    // Delete the file
    ref.delete().then(() => {
        window.location = "/admin/promotion"
    }).catch((error) => {
        window.location = "/admin/promotion"
    });
}

export const promotionUpdateById = (id, data, oldFiles) => {
    return (dispatch) => {
        dispatch({ type: PROMOTION_UPDATE, payload: true })
        if(data.thumbnail && data.photo) {
            // Change both thumbnail and photo
            const storage = firebase.storage().ref()
            // Upload thumbnail
            const filename = Date.now()+"."+data.thumbnail.name.split('.').pop()
            const fileRef = storage.child('promotion/'+filename)
            fileRef.put(data.thumbnail).then(()=>{
                fileRef.getDownloadURL().then((url) => {
                    data.thumbnail = url
                    // Upload Photo
                    const filename2 = Date.now()+"."+data.photo.name.split('.').pop()
                    const fileRef2 = storage.child('promotion/'+filename2)
                    fileRef2.put(data.photo).then(()=>{
                        fileRef2.getDownloadURL().then((url) => {
                            data.photo = url
                            firebase.database().ref('promotions/'+id).update(data)
                            .then(res => {
                                removeTwoOldFile(oldFiles)
                            })
                            .catch(err => {
                                dispatch({ type: PROMOTION_UPDATE, payload: false })
                            })
                        })
                    })
                })
            })
        } else if (data.thumbnail && data.photo === "" ) {
            // Change Thumbnail
            const storage = firebase.storage().ref()
            // Upload thumbnail
            const filename = Date.now()+"."+data.thumbnail.name.split('.').pop()
            const fileRef = storage.child('promotion/'+filename)
            fileRef.put(data.thumbnail).then(()=>{
                fileRef.getDownloadURL().then((url) => {
                    delete data.photo
                    data.thumbnail = url
                    firebase.database().ref('promotions/'+id).update(data)
                    .then(res => {
                        removeOldFile(oldFiles.oldThumbnail)
                    }).catch(err => {
                        dispatch({ type: PROMOTION_UPDATE, payload: false })
                    })
                })
            })
        } else if (data.thumbnail === "" && data.photo) {
            // Change Photo
            const storage = firebase.storage().ref()
            // Upload photo
            const filename = Date.now()+"."+data.photo.name.split('.').pop()
            const fileRef = storage.child('promotion/'+filename)
            fileRef.put(data.photo).then(()=>{
                fileRef.getDownloadURL().then((url) => {
                    delete data.thumbnail
                    data.photo = url
                    firebase.database().ref('promotions/'+id).update(data)
                    .then(res => {
                        removeOldFile(oldFiles.oldPhoto)
                    }).catch(err => {
                        dispatch({ type: PROMOTION_UPDATE, payload: false })
                    })
                })
            })
        } else if (data.thumbnail === "" && data.photo === "") {
            // No file change
            delete data.thumbnail
            delete data.photo
            firebase.database().ref('promotions/'+id).update(data)
            .then(res => window.location = "/admin/promotion")
            .catch(err => dispatch({ type: PROMOTION_UPDATE, payload: false }))
        }
    }
}

export const promotionFetchById = (id) => {
    return (dispatch) => {
        let	promotionsRef = firebase.database().ref('promotions/'+id)
		promotionsRef.once('value', snapshot => {
			dispatch({ type: PROMOTION_FETCH_BY_ID, payload: snapshot.val() });
		})
    }
}

export const promotionFetch = () => {
    return (dispatch) => {
        let	promotionsRef = firebase.database().ref('promotions')
		promotionsRef.once('value', snapshot => {
			let data = []
			snapshot.forEach(childSnapshot => {
                let item = childSnapshot.val()
                data.push(item)
			})
			dispatch({ type: PROMOTION_FETCH, payload: data.reverse() });
		})
    }
}

export const promotionCreate = (data) => {
    return (dispatch) => {
        dispatch({ type: PROMOTION_CREATE, payload: true })
        const filename = Date.now()+"."+data.photo.name.split('.').pop()
        const storage = firebase.storage().ref()
        let fileRef = storage.child('promotion/'+filename)
        // upload photo
        fileRef.put(data.photo).then(()=>{
            fileRef.getDownloadURL().then((url) => {
                data.photo = url
                // upload thumbnail
                const filename2 = Date.now()+"."+data.thumbnail.name.split('.').pop()
                fileRef = storage.child('promotion/'+filename2)
                fileRef.put(data.thumbnail).then(()=>{
                    fileRef.getDownloadURL().then((url2) => {
                        data.thumbnail = url2
                        // Create promotion databse
                        const promotionsRef = firebase.database().ref('promotions').push()
                        const id = promotionsRef.key
                        data.id = id
                        promotionsRef.set(data)
                        .then(response => {
                            window.location = "/admin/promotion"
                        })
                        .catch(err => {
                            dispatch({ type: PROMOTION_CREATE, payload: false })
                            console.log("promotionCreate", err)
                        })
                    })
                })
            })
        })
    }
}



// // Remove file from firebase storage
// const removeOldFile = (src) => {
//     var ref = firebase.storage().ref().child(src);
//     // Delete the file
//     ref.delete().then(() => {
//         window.location = "/admin/privilege"
//     }).catch((error) => {
//         window.location = "/admin/privilege"
//     });
// }

// // Upload File to firebase storage
// const uploadFile = async (file) => {
//     const filename = Date.now()+"."+file.name.split('.').pop()
//     const storage = firebase.storage().ref()
//     const fileRef = storage.child(filename)
//     fileRef.put(file).then(()=>{
//         fileRef.getDownloadURL().then((url) => {
//             return url
//         }).catch((error) => {
//             console.log(error)
//             return ""
//         })
//     })
// }